import { Image } from "../Models/Image";
import { FeedbackFile } from "../Models/FeedbackFile";

class FileService {
  fileListToFileArray(fileList: FileList): File[] {
    const files = [];

    for (let i = 0; i < fileList.length; i++) {
      files.push(fileList[i]);
    }

    return files;
  }

  fileListToImages(fileList: FileList): Image[] {
    return this.filestoImages(this.fileListToFileArray(fileList));
  }

  filestoImages(files: File[]): Image[] {
    return files.map((file: File) => {
      return {
        file
      } as Image;
    });
  }

  fileListToFeedbackFiles(fileList: FileList, isCadmakersOnly: boolean): FeedbackFile[] {
    return this.filestoFeedbackFiles(this.fileListToFileArray(fileList), isCadmakersOnly);
  }

  filestoFeedbackFiles(files: File[], isCadmakersOnly: boolean): FeedbackFile[] {
    return files.map((file: File) => {
      return {
        file,
        isCadmakersOnly
      } as FeedbackFile;
    });
  }
}

export const fileService = new FileService();
